import { filterOptions } from "@src/helpers/constants";
import { Form, Select } from "antd";
import React from "react";

const SubjectBloodGroup: React.FC = () => {
  return (
    <Form.Item
      name="bloodGroup"
      label="Blood Group"
      rules={[
        {
          required: true,
          message: "Please select the blood group",
        },
      ]}
    >
      <Select placeholder="" options={filterOptions.bloodGroup} />
    </Form.Item>
  );
};

export default SubjectBloodGroup;
